import React from 'react';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import InputLabel from '@material-ui/core/InputLabel';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import CardHeader from '../../sharedComponents/Card/CardHeader';
import useStyles from './styles';

const Modal = (props) => {
  const {
    open,
    seg4w,
    update,
    paises,
    empresas,
    segmentos,
    categorias,
    handleClose,
    handleUpdate,
    subsegmetos,
    subcategorias,
    onChangeInputSelector,
  } = props;
  const classes = useStyles();

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <form onSubmit={handleUpdate}>
          <DialogContent className={classes.formControl}>
            <CardHeader color="customAuteco">
              <h6 className={classes.cardTitleWhite}>Nueva Segmentación</h6>
              <p>
                Unidades
                {' '}
                {update.unidades}
              </p>
            </CardHeader>
            <Grid container spacing={2}>
              <Grid item>
                <div className={classes.textField}>
                  <h6>
                    Marca:
                    {' '}
                    <p>{update.marca}</p>
                  </h6>
                </div>
              </Grid>
              <Grid item>
                <div className={classes.textField}>
                  <h6>
                    Linea:
                    {' '}
                    <p>{update.linea}</p>
                  </h6>
                </div>
              </Grid>
              <Grid item>
                <div className={classes.textField}>
                  <h6>
                    Carrocería:
                    {' '}
                    <p>{update.carroceria}</p>
                  </h6>
                </div>
              </Grid>
              <Grid item>
                <div className={classes.textField}>
                  <h6>
                    Combustible:
                    {' '}
                    <p>{update.combustible}</p>
                  </h6>
                </div>
              </Grid>
              {!seg4w && (
                <>
                  <Grid item>
                    <div className={classes.textField}>
                      <h6>
                        Clase:
                        {' '}
                        <p>{update.clase}</p>
                      </h6>
                    </div>
                  </Grid>
                  <Grid item>
                    <div className={classes.textField}>
                      <h6>
                        Ensambladora:
                        {' '}
                        <p>{update.ensambladora}</p>
                      </h6>
                    </div>
                  </Grid>
                </>
              )}
              {seg4w && (
                <>
                  <Grid item>
                    <div className={classes.textField}>
                      <h6>
                        Clase:
                        {' '}
                        <p>{update.clase}</p>
                      </h6>
                    </div>
                  </Grid>
                  <Grid item>
                    <div className={classes.textField}>
                      <h6>
                        Segmento Runt:
                        {' '}
                        <p>{update.segmento_runt}</p>
                      </h6>
                    </div>
                  </Grid>
                </>
              )}
              <FormControl required className={classes.formControl}>
                <InputLabel htmlFor="inputNativo">1. Categoría.</InputLabel>
                <Select
                  required
                  id="categoria"
                  defaultValue={update.categoria}
                  onChange={(event) => onChangeInputSelector('categoria', event.target.value)}
                  className={classes.textField}
                >
                  {categorias.map((value) => (
                    <MenuItem key={value.id} value={value}>
                      <ListItemText primary={value.categoria} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl required className={classes.formControl}>
                <InputLabel id="demo-dialog-select-label">
                  2. SubCategoría.
                </InputLabel>
                <Select
                  id="subcategoria"
                  defaultValue={update?.subcategoria || ''}
                  onChange={(event) => onChangeInputSelector('subcategoria', event.target.value)}
                  className={classes.textField}
                >
                  {subcategorias.map((value) => (
                    <MenuItem key={value.id} value={value}>
                      <ListItemText primary={value.subcategoria} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl required className={classes.formControl}>
                <InputLabel htmlFor="inputNativo">3. Segmento.</InputLabel>
                <Select
                  id="segmento"
                  required
                  defaultValue={update?.segmento || ''}
                  onChange={(event) => onChangeInputSelector('segmento', event.target.value)}
                  className={classes.textField}
                >
                  {segmentos.map((value) => (
                    <MenuItem key={value.id} value={value}>
                      <ListItemText primary={value.segmento} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl required className={classes.formControl}>
                <InputLabel id="demo-dialog-select-label">
                  4. SubSegmento.
                </InputLabel>
                <Select
                  id="subsegmento"
                  required
                  defaultValue={update?.subsegmento || ''}
                  onChange={(event) => onChangeInputSelector('subsegmento', event.target.value)}
                  className={classes.textField}
                >
                  {subsegmetos.map((value) => (
                    <MenuItem
                      key={value.id}
                      value={value.experimental === '1' ? null : value}
                    >
                      <ListItemText
                        primary={
                            value.experimental === '1'
                              ? null
                              : value.subsegmento
                          }
                      />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl required className={classes.formControl}>
                <InputLabel id="demo-dialog-select-label">Empresa</InputLabel>
                <Select
                  required
                  id="selector"
                  defaultValue={update.empresa}
                  className={classes.textField}
                  onChange={(event) => onChangeInputSelector('empresa', event.target.value)}
                >
                  {empresas.map((value) => (
                    <MenuItem key={value.id} value={value}>
                      <ListItemText primary={value.empresa} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl required className={classes.formControl}>
                <InputLabel id="demo-dialog-select-label">
                  Pais Origen
                </InputLabel>
                <Select
                  required
                  id="selector"
                  defaultValue={update.origen}
                  className={classes.textField}
                  onChange={(event) => onChangeInputSelector('pais', event.target.value)}
                >
                  {paises.map((value) => (
                    <MenuItem key={value.id} value={value}>
                      <ListItemText
                        primary={`${value.pais} ${value.capital} ${value.continente}`}
                      />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary">
              Cerrar
            </Button>
            <Button
              autoFocus
              variant="contained"
              color="danger"
              type="onSubmit"
            >
              Guardar
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default Modal;
